import React from 'react';
import _ from "lodash"
import moment from 'moment';

const ProgramDetailCell = (props) => {
        const {data,isCne} = props;
        let apcmCandidate = false;
        let apcmPatient = false;
        if(data.program_type === 'apcm'){
            apcmPatient = true;
        }else if(data.program_type === 'ccm' ){
            if(data.apcm_enrollment === 'Candidate' && data.apcm_eligible_level){
                apcmCandidate = true;
            } 
        }

       
        let programType = data.program_type;
        if(programType === 'ccm'){
                programType = 'CCM';
        }else if(programType === 'pathways_stroke_care'){
                programType = 'Pathways Stroke Care';
        }else if(programType === 'apcm'){
                programType = 'APCM';
        }

        return <div>
                <div style={{fontWeight:400}}>
                        Program: {programType}
                </div>
                {
                        (apcmPatient || apcmCandidate) && <div className="value-box" style={{ width: "100%", display:'flex', flex:1, flexDirection:'column'}}>
                                
                                { 
                                        !isCne && <div style={{display:'flex',justifyContent:'flex-start', padding:0}}>
                                                <span style={{fontWeight:400}}>APCM Service Level:</span>
                                                <span style={{paddingLeft:15}}>{data.apcm_service_level ? data.apcm_service_level : '-'}</span>
                                        </div>
                                }
                                <div style={{display:'flex',justifyContent:'flex-start', padding:0}}>
                                        <span style={{fontWeight:400}}>APCM Eligible Level:</span>
                                        <span style={{paddingLeft:15}}>{data.apcm_eligible_level ? data.apcm_eligible_level : '-'}</span>
                                </div>
                                {
                                        data.call_due_date &&  <div style={{display:'flex',justifyContent:'flex-start', padding:0}}>
                                                <span style={{fontWeight:400}}>APCM Target Date:</span>
                                                <span style={{paddingLeft:15}}>{data.call_due_date ? moment(data.call_due_date).format("MM/DD/YYYY")    : '-'}</span>
                                        </div>
                                }
                               
                    </div> 

                }
                
               
        </div>
};

export default ProgramDetailCell;
